// Undo an anchored point; the cursor preview continues from the remaining last anchor.
export const undoFreeDrawStep = (state) => {
  if (state.addedPoints.length > 0) {
    const lastPoint = state.addedPoints.pop();
    if (lastPoint && lastPoint.destroy) {
      lastPoint.destroy();
    }
    const lastDimension = state.dimensions.pop();
    if (lastDimension && lastDimension.destroy) {
      lastDimension.destroy();
    }
  }

  state.currentNumericInput = "";
  state.drawLineToMouse = state.addedPoints.length > 0;
  if (state.dimensionToMouse) {
    state.dimensionToMouse.destroy();
    state.dimensionToMouse = null;
  }
};
